import React from 'react';
import clsx from 'clsx';

import { ArrowSpinnerColour } from 'components/Spinner/constants';
import { ButtonColour, ButtonStyle } from 'components/Button/constants';
import { FormControlProps } from './Default';
import * as Button from 'components/Button';
import Spinner from 'components/Spinner';

import styles from './styles.module.scss';

const FormControl: React.FC<FormControlProps> = ({
  handleBack,
  isSubmitting,
  isUserFromPeopleCert,
}) => {
  const classNames = clsx(
    styles.formControl,
    isSubmitting && styles.submitting,
    styles[`step2`],
  );

  return (
    <div className={classNames}>
      <Button.Generic
        colour={ButtonColour.BRAND_MONO_ONE}
        disabled={isSubmitting}
        label="Back"
        onClick={handleBack}
        style={ButtonStyle.SECONDARY}
      />
      <p>Step 2 of 2</p>
      <Button.Submit
        colour={ButtonColour.BRAND_BLACK_GRAPE}
        disabled={true} // remove after PeopleCert+ transition
        // disabled={isSubmitting}
        label={isUserFromPeopleCert ? 'Create account' : 'Confirm and pay'}
        style={ButtonStyle.SECONDARY}
        showSpinner={false}
      >
        {isSubmitting && (
          <Spinner
            background={false}
            className={styles.spinner}
            colour={ArrowSpinnerColour.WHITE}
          />
        )}
      </Button.Submit>
    </div>
  );
};

export default React.memo(FormControl);
